<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-xl="10" offset-xl="1">
                <div class="padding">

                    <h1 class="h3">Zaproś uczestnika</h1>

                    <div class="box">
                        <form class="form form-set-password" @submit.prevent="submitInvitation">
                            <ion-row>
                                <ion-col size="12" size-md="6">
                                    <div class="form-group mb-0">
                                        <label>Typ uczestnika:</label>
                                        <div class="select-wrapper">
                                            <span v-if="form.type === null" class="select-placeholder">Wybierz typ uczestnika</span>
                                            <select v-model="form.type" required>
                                                <option v-for="item in userTypesCollection" :key="item.id" :value="item.id">{{ item.value }}</option>
                                            </select>
                                        </div>
                                        <p class="error" v-if="errors.type">
                                            <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                            <span v-text="errors.type"></span>
                                        </p>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="6">
                                    <div class="form-group mb-0">
                                        <label>Prefix systemu:</label>
                                        <div class="select-wrapper">
                                            <span v-if="form.prefix === null" class="select-placeholder">Wybierz prefix systemu</span>
                                            <select v-model="form.prefix" required>
                                                <option v-for="item in userPrefixesCollection" :key="item.id" :value="item.id">{{ item.value }}</option>
                                            </select>
                                        </div>
                                        <p class="error" v-if="errors.prefix">
                                            <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                            <span v-text="errors.prefix"></span>
                                        </p>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="6">
                                    <div class="form-group mb-0">
                                        <label>Numer identyfikacyjny uczestnika:</label>
                                        <input v-model="form.user_id" type="number" :class="{'input-error' : errors.user_id }" placeholder="Podaj numer SAP" required/>
                                        <p class="error" v-if="errors.user_id">
                                            <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                            <span v-text="errors.user_id"></span>
                                        </p>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="6">
                                    <div class="form-group mb-0">
                                        <label>Numer telefonu uczestnika:</label>
                                        <input v-model="form.phone" type="tel" maxlength="9" :class="{'input-error' : errors.phone }" placeholder="Podaj numer telefonu" required/>
                                        <p class="error" v-if="errors.phone">
                                            <svg class="voxion"><use xlink:href="#icon-alert"></use></svg>
                                            <span v-text="errors.phone"></span>
                                        </p>
                                    </div>
                                </ion-col>
                            </ion-row>
                            <button class="btn btn-primary" type="submit" :disabled=loadingButton>
                                <span v-if="loadingButton"><span class="loader"></span></span>
                                <span v-else>Wyślij zaproszenie</span>
                            </button>
                        </form>

                        <notification v-if="notification" type="success" :text="notificationText"></notification>

                    </div>

                    <div class="text-left mt-10 mb-20" style="margin-left: 5px">
                        <button class="link" @click="goToList">
                            <svg><use xlink:href="#icon-details"></use></svg>
                            <span>Lista zaproszeń</span>
                        </button>
                    </div>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import api from '@/services/Api';
    import notification from '../../components/Notification'

    function getDefaultFormData() {
        return {
            type: null,
            prefix: null,
            user_id: null,
            phone: null
        }
    }

    export default {
        name: 'InvitationsIndex',
        components: { notification },
        data(){
            return{
                loadingButton: false,
                errors: [],

                notification: false,
                notificationText: '',

                userTypesCollection: [],
                userPrefixesCollection: [],

                form: getDefaultFormData()
            }
        },
        mounted(){
            this.getUserTypes();
        },
        methods: {
            getUserTypes() {
                api.get('/api/v1/configuration/user_types').then(response => {
                    this.userTypesCollection = response.data.data.value
                });
                api.get('/api/v1/configuration/prefix_od_types_of_users_databases').then(response => {
                    this.userPrefixesCollection = response.data.data.value
                })
            },
            submitInvitation() {
                this.loadingButton = true;
                api.post('/api/v1/invitations/post', this.form).then(response => {
                    this.errors = [];
                    this.loadingButton = false;
                    if(response.data.code === 200){
                        this.notification = true;
                        this.notificationText = response.data.message;
                        this.form = getDefaultFormData()
                    }
                }).catch(err => {
                    this.loadingButton = false;
                    this.errors = err.response.data.errors
                })
            },
            goToList() {
                this.$router.push({ name: 'InvitationsList' })
            }
        }
    }
</script>